module.exports = __webpack_public_path__ + "img/note.4fa5d9c2.png";